// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
export default noopTheme;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/getStylesCreator/noopTheme.js
// module id = 848
// module chunks = 121